export const convertCamelCaseToSpaces = (s: string): string => {
  const arr = s.split(/([A-Z][a-z]+)/).filter((e) => {
    return e
  })
  return arr.join(" ")
}
